import classNames from 'classnames';
import React, { FC, forwardRef } from 'react';
import { useStyles } from './SelectInput.styles';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Select from 'react-select';
import { SelectOption } from 'shared/interfaces';

interface SelectInputProps {
  options: SelectOption<number | string>[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (value: any) => void;
  value?: unknown;
  disabled?: boolean;
  isTextMode?: boolean;
  placeholder?: string;
}

export const SelectInput: FC<SelectInputProps> = forwardRef(
  ({ isTextMode, options, onChange, value, disabled, placeholder }, ref) => {
    const { classes } = useStyles();

    return (
      <>
        {isTextMode ? (
          <div>{value as string}</div>
        ) : (
          <Select
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            theme={(theme) => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary: '#6e03f6',
              },
            })}
            isDisabled={disabled}
            inputRef={ref}
            options={options}
            className={classNames(classes.root, 'react-select')}
            classNamePrefix="react-select"
            value={options.find((option: SelectOption) => option.value === value)}
            onChange={(option: SelectOption) => onChange(option.value)}
            placeholder={placeholder}
          />
        )}
      </>
    );
  }
);
